export const APP_NAME = 'RAemContentTable'
